import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { AppStateType } from '../../reducers'
import { selectServerConfig } from '../../selectors/config'
import { selectPack } from '../../selectors/pack'
import { selectDataChart } from '../../selectors/datachart'
import {
  CreateDataChartForm as Component,
  ICreateDataChartForm,
} from './CreateDataChartForm'

const mapStateToProps = (state: AppStateType) => ({
  pack: selectPack(state),
  datachart: selectDataChart(state),
  serverConfig: selectServerConfig(state),
})

export const CreateDataChartForm = withRouter(
  connect(mapStateToProps)(Component)
) as React.FC<ICreateDataChartForm>
